import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { Content } from '../../lib/FL';
import { ModalDispatchContext } from '../../contexts/ModalProvider';
import ContentPreviewModal from '../modal/ContentPreviewModal';

import styles from './CardLink.module.scss';

type ContentLinkProps = {
  content: Content;
};

const CardLink: React.FC<ContentLinkProps> = ({ content, children }) => {
  const dispatch = useContext(ModalDispatchContext);
  return (
    <>
      <button
        className={styles.link}
        onClick={() => dispatch(() => <ContentPreviewModal content={content} />)}
        type='button'
      >
        {children}
      </button>
      <Link className={`${styles.link} ${styles.link_sp}`} to={`/content/${content.en_name}`} target='_blank'>
        {children}
      </Link>
    </>
  );
};

export default CardLink;
